import {
    AppThunk,
    createDispatchActionSet,
    fetchWithNotification,
} from './base.action'
import integrationApi from 'Services/api/integration.service'
import { IntegrationsType } from 'constant/integrations'
import { setBreadCrumbMapping } from './breadCrumb.action'

export const getAllIntegrationsActions = createDispatchActionSet<any>(
    'GET_ALL_INTEGRATIONS',
)
export const getIntegrationActions = createDispatchActionSet<any>(
    'GET_INTEGRATION',
)
export const addIntegrationActions = createDispatchActionSet('ADD_INTEGRATION')
export const updateIntegrationActions = createDispatchActionSet(
    'UPDATE_INTEGRATION',
)
export const deleteIntegrationActions = createDispatchActionSet(
    'DELETE_INTEGRATION',
)

export const INTEGRATION_RESET_FORM = 'INTEGRATION_RESET_FORM'

export const getAllIntegrations = (type: IntegrationsType): AppThunk => async (
    dispatch,
) => {
    try {
        dispatch(getAllIntegrationsActions.pending())

        const results = await fetchWithNotification({
            apiLinkFnc: () =>
                Promise.all([
                    integrationApi.getAllIntegrations(type),
                    integrationApi.getLocationIntegrations(),
                ]),
        })

        const result = results[0]
        const locResult = results[1]

        dispatch(
            getAllIntegrationsActions.success({
                integrations: result.data,
                locationIntegrations: locResult.data,
            }),
        )
    } catch (error) {
        dispatch(getAllIntegrationsActions.failed(error))
    }
}
export const getIntegration = (id: number): AppThunk => async (dispatch) => {
    try {
        dispatch(getIntegrationActions.pending())
        const results = await fetchWithNotification({
            apiLinkFnc: () =>
                Promise.all([
                    integrationApi.getIntegration(id),
                    integrationApi.getLocationIntegration(id),
                ]),
        })
        const metadata = results[0].data
        const locationIntegration = results[1].data
        dispatch(
            getIntegrationActions.success({
                metadata: metadata,
                integration: locationIntegration,
            }),
        )
        dispatch(
            setBreadCrumbMapping({
                key: id.toString(),
                value: metadata.name!!,
            }),
        )
    } catch (error) {
        dispatch(getIntegrationActions.failed(error))
    }
}

export const addIntegration = (
    integrationId: number,
    data: any,
): AppThunk => async (dispatch) => {
    try {
        dispatch(addIntegrationActions.pending())

        await fetchWithNotification({
            apiLinkFnc: () =>
                integrationApi.addIntegration(integrationId, data),
            successMessage: 'create success',
        })
        dispatch(addIntegrationActions.success())
    } catch (error) {
        dispatch(addIntegrationActions.failed(error))
    }
}

export const updateIntegration = (
    integrationId: number,
    data: any,
): AppThunk => async (dispatch) => {
    try {
        dispatch(updateIntegrationActions.pending())
        await fetchWithNotification({
            apiLinkFnc: () =>
                integrationApi.updateIntegration(integrationId, data),
            successMessage: 'update success',
        })
        dispatch(updateIntegrationActions.success())
    } catch (error) {
        dispatch(updateIntegrationActions.failed(error))
    }
}

export const resetIntegrationForm = () => ({
    type: INTEGRATION_RESET_FORM,
})
